document.addEventListener("DOMContentLoaded", function () {
  /********** SOMETIMES **********/
  // if (document.querySelector(".b-hero-1__video-button")) {
  //   BHERO1.init();
  // }

  if (document.querySelector(".b-references")) {
    BREFERENCES.init();
  }

  if (document.querySelector(".b-all-references")) {
    BALLREFERENCES.init();
  }

  // if (
  //   document.querySelector(".c-reference") ||
  //   document.querySelector(".c-reference-2")
  // ) {
  //   CREFERENCE.init();
  // }

  /********** ALWAYS **********/
  MENU.init();
});
